import { formValueSelector } from 'redux-form';
import { getPrice, getSelected } from '../../single-choice/utils/selection';
export const createPickAndChooseProduct = config => {
  const formSection = config.product.name;
  const getAvailability = form => state => {
    var _ref, _formData$value$cartB, _formData$value;
    const formData = formValueSelector(form)(state, formSection);
    return (_ref = (_formData$value$cartB = formData === null || formData === void 0 || (_formData$value = formData.value) === null || _formData$value === void 0 ? void 0 : _formData$value.cartBreakDown) !== null && _formData$value$cartB !== void 0 ? _formData$value$cartB : formData === null || formData === void 0 ? void 0 : formData.cartBreakDown) !== null && _ref !== void 0 ? _ref : null;
  };
  return {
    formSection,
    getSelected: getSelected.bind(null, formSection),
    getPrice: getPrice.bind(null, formSection),
    getAvailability
  };
};
export default createPickAndChooseProduct;
//# sourceMappingURL=createPickAndChooseProduct.js.map